import { Injectable, Injector } from "@angular/core";

import { StorageService } from "../service/storage.service";
import {
  LOGIN_TOKEN,
  LocalStorageConst,
  CULTURE_INFO,
  MICROSOFT_TOKEN,
} from "~common/config/constants";

@Injectable({
  providedIn: "root",
})
export class TokenInterceptorService {
  constructor(private injector: Injector) {}

  intercept(req, next) {
    const sessionService = this.injector.get(StorageService);
    const tokenizedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${sessionService.getDataSession(LOGIN_TOKEN)}`,
        MicrosoftAuth: `${sessionService.getDataSession(MICROSOFT_TOKEN)}`,
      },
    });
    return next.handle(tokenizedReq);
  }
}
